import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  list,
  create,
  get,
  edit,
  remove,
  order,
  bulk_remove,
} from '../../../features/score-cards/actions';

const index = () => {
  const page = 'Score Cards';
  return (
    <div style={{ height: '100%', paddingTop: '4rem' }}>
      <Outlet
        context={[
          { page, list, create, get, edit, remove, order, bulk_remove },
        ]}
      />
    </div>
  );
};

export default index;
